export default __webpack_public_path__ + "static/media/poll-card.e89a7e3a.png";